import _ from 'lodash';
import css from 'styled-jsx/css';
import constants from '../../config/constants';
import { colors } from '../../config/styles';
import { CookieStorage } from '../../utils/CookieStorage';
import { capitalizeString } from '../../utils/jsUtils';
import { CURRENCY_MAPPER, formatters } from '../../utils/PriceHelpers';
import { WebStorage } from '../../utils/WebStorage';

const shippingEstimatedPriceStyles = css`
  .arrival-label {
    font-weight: 700;
    color: ${colors.green.shade25};
  }
`;

function hasValidShippingEstimatedPrice(shippingEstimatedPrice) {
  const deliveryCost = shippingEstimatedPrice?.deliveryCost;
  if (!deliveryCost) {
    return false;
  }

  const { centAmount, fraction, currency } = deliveryCost;
  return Boolean(centAmount && fraction && currency);
}

function getFormattedShippingEstimatedPrice(shippingEstimatedPrice, meatStickers) {
  const { centAmount, fraction, currency } = shippingEstimatedPrice?.deliveryCost ?? {};
  const label = meatStickers?.[0]?.label || 'Llega mañana';
  const connector = 'por';
  const formattedPrice = formatters.DOT_SEPERATOR(centAmount / fraction);

  return (
    <>
      <span className="estimated-shipping-price">
        <span className="arrival-label">{label}</span> {connector} {CURRENCY_MAPPER[currency] || ''}
        {formattedPrice}
      </span>
      <style jsx>{shippingEstimatedPriceStyles}</style>
    </>
  );
}

const getMetaKey = (shippingOption) => {
  switch (shippingOption) {
    case constants.AVAILABILITY_HOMEDELIVERY: {
      return {
        labelsKey: {
          title: 'HOME_DELI_TITLE',
          selectorTitle: 'HOME_DELI_SELECTOR_TITLE',
          outOfStock: 'HOME_DELI_OUTOFSTOCK',
          subPrefix: 'HOME_DELI_SUB_PREFIX',
          pleaseSelect: 'HOME_DELI_STORE_PLEASE_SELECT',
          seeMoreOptions: 'HOME_DELI_SEE_MORE_OPTIONS',
          localStorageRegionKey: 'REGION_S',
          localStorageComunaKey: 'COMUNA_S',
          localStorageCiudadKey: 'CIUDAD_S',
          localAvailableTextDisplayKey: 'COMUNA_S',
        },
      };
    }
    case constants.AVAILABILITY_PICKUPINSTORE: {
      return {
        labelsKey: {
          title: 'PICKUP_INSTORE_TITLE',
          selectorTitle: 'PICKUP_INSTORE_SELECTOR_TITLE',
          subPrefix: 'PICKUP_INSTORE_SUB_PREFIX',
          outOfStock: 'PICKUP_INSTORE_OUTOFSTOCK',
          pleaseSelect: 'PICKUP_INSTORE_PLEASE_SELECT',
          seeMoreOptions: 'PICKUP_INSTORE_SEE_MORE_OPTIONS',
          localStorageRegionKey: 'REGION_PU',
          localStorageComunaKey: 'COMUNA_PU',
          localAvailableTextDisplayKey: 'STORE_PU',
        },
      };
    }
    case constants.AVAILABILITY_STOCKINSTORE: {
      return {
        labelsKey: {
          title: 'STOCK_IN_STORE',
          selectorTitle: 'STOCK_IN_STORE_SELECTOR_TITLE',
          outOfStock: 'STOCK_IN_STORE_OUTOFSTOCK',
          pleaseSelect: 'CHECK',
          localStorageRegionKey: 'REGION_SI',
          localStorageComunaKey: 'COMUNA_SI',
          localAvailableTextDisplayKey: 'STORE_SI',
        },
      };
    }
    case constants.AVAILABILITY_PURCHASEONLINE: {
      return {
        labelsKey: {
          title: 'PURCHASE_ONLINE_TITLE',
          outOfStock: 'PURCHASE_ONLINE_OUTOFSTOCK',
        },
      };
    }
    default: {
      return {};
    }
  }
};

const getSelectionText = ({ labelsData, labelsKey, persistedText }) => {
  if (!_.isEmpty(persistedText)) {
    return '';
  }
  return labelsData[labelsKey.title];
};

const getSelectedCommuna = ({
  shippingOptionType,
  AVAILABILITY_HOMEDELIVERY,
  COOKIE_HOME_DELIVERY_KEY,
  COOKIE_STORE_PICKUP_KEY,
  LS_HOME_DELIVERY_KEY,
  LS_STORE_PICKUP_KEY,
}) => {
  const isHD = shippingOptionType === AVAILABILITY_HOMEDELIVERY;

  // Get availabilityCookieValue Cookie
  const availabilityCookieValue = CookieStorage.getCookie(isHD ? COOKIE_HOME_DELIVERY_KEY : COOKIE_STORE_PICKUP_KEY);
  // Decode cookie value
  const availabilityCookieDecoded = CookieStorage.parseCookieValue(
    isHD ? COOKIE_HOME_DELIVERY_KEY : COOKIE_STORE_PICKUP_KEY,
    availabilityCookieValue
  );
  // Store comuna data for HD or CC in the LS
  if (availabilityCookieDecoded) {
    // Save HD or CC information to local storage
    WebStorage.setItem({
      name: isHD ? LS_HOME_DELIVERY_KEY : LS_STORE_PICKUP_KEY,
      value: JSON.stringify(availabilityCookieDecoded),
      shouldPersist: true,
    });
    return availabilityCookieDecoded.displayName;
  }
  // Get HD or CC from LS
  const selection = WebStorage.getItem({
    name: isHD ? LS_HOME_DELIVERY_KEY : LS_STORE_PICKUP_KEY,
    fromPersistence: true,
  });

  if (selection) {
    return JSON.parse(selection).displayName;
  }

  return '';
};

// const getContent = ({ actions, shippingOptionType, currentVariant, handleAvailabilityUpdate }) => (
//   <AvailabilityModal
//     actions={actions}
//     type={shippingOptionType}
//     variant={currentVariant}
//     onUpdate={handleAvailabilityUpdate}
//   />
// );

const renderOOSView = ({ labelsData, outOfStock, comunaName, parentStateName, styles }) => {
  return (
    <div className="content-main outofstock">
      <div className="content-main">
        <span className="no-delivery">{labelsData[`${outOfStock}`]}</span>
        <span className="no-delivery-comuna">
          {comunaName ? `${capitalizeString(comunaName)}, ${capitalizeString(parentStateName)}` : ''}
        </span>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export {
  // getContent,
  getFormattedShippingEstimatedPrice,
  getMetaKey,
  getSelectedCommuna,
  getSelectionText,
  hasValidShippingEstimatedPrice,
  renderOOSView,
  shippingEstimatedPriceStyles,
};
